export default __webpack_public_path__ + "media/images/user_photos/56-48461d84d582bf35b1fa423059af4dc0.jpg";